import { useNavigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
function DainandinNondvahiTandulkReport() {
  const location = useLocation();
  const { selectedDate, selectedClass } = location.state || {};
  const language = localStorage.getItem("language");
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [schoolData, setSchoolData] = useState(null); 
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(true);
  const [countTotal, setCountTotal] = useState('');
  const [expenseData, setExpenseData] = useState({}); 
  const [expenseValue, setExpenseValue] = useState(0); // Add this line
  const [currentMonthTandul, setCurrentMonthTandul] = useState(0); // Add state for current month tandul

  const navigate = useNavigate();
  const [rowInputData, setRowInputData] = useState(
  modalData.map(() => ({
    supplementaryFood: ' ',
    beneficiaryExpenditure: ''
  }))
);
  const marathiMonths = {
    January: 'जानेवारी',
    February: 'फेब्रुवारी',
    March: 'मार्च',
    April: 'एप्रिल',
    May: 'मे',
    June: 'जून',
    July: 'जुलै',
    August: 'ऑगस्ट',
    September: 'सप्टेंबर',
    October: 'ऑक्टोबर',
    November: 'नोव्हेंबर',
    December: 'डिसेंबर'
  };
  const monthMapping = {
    '01': 'January',
    '02': 'February',
    '03': 'March',
    '04': 'April',
    '05': 'May',
    '06': 'June',
    '07': 'July',
    '08': 'August',
    '09': 'September',
    '10': 'October',
    '11': 'November',
    '12': 'December'
  };
  const classMapping = {
    '1 To 5': {
      English: "1 To 5",
      Marathi: "१ ली ते ५ वी"
    },
    '6 To 8': {
      English: "6 To 8",
      Marathi: "६ वी ते ८ वी"
    }
  };
  

const dateObject = new Date(selectedDate);
const year = dateObject.getFullYear(); 
const month = String(dateObject.getMonth() + 1).padStart(2, '0'); 
const englishMonthName = dateObject.toLocaleString('default', { month: 'long' });

const monthName = language === "English" ? englishMonthName:  marathiMonths[englishMonthName] ;

const fetchCurrentMonthTandul = async (year, monthName) => {

  const month = monthMapping[monthName];
  
  const currentMonthUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/avaksatha/${selectedClass}/${year}/${month}/vastuDetails.json`;


  try {
    const response = await axios.get(currentMonthUrl);
    const data = response.data || {};
    const currentMonthTandul = data['तांदूळ'] || data['Rice']||  0; 
    
    return currentMonthTandul;
  } catch (error) {
    console.error('Error fetching current month tandul:', error);
    return 0; // Return 0 if there's an error
  }
};
const fetchRemainingStock = async (year, month) => {
  const previousMonthDate = new Date(year, new Date(`${month} 1, ${year}`).getMonth() - 1);
  const previousMonth = previousMonthDate.toLocaleString('default', { month: 'long' });
  const previousYear = previousMonthDate.getFullYear();

  const sadhyachaSathaUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/sadhyachasatha/${selectedClass}/${previousYear}/${previousMonth}.json`;
  
  try {
    const response = await axios.get(sadhyachaSathaUrl);
    const sadhyachaData = response.data || {};

    // Get the remaining stock for तांदूळ
    const remainingTandul = sadhyachaData['तांदूळ'] || sadhyachaData['Rice'] || 0; // Default to 0 if not found
    return remainingTandul;
  } catch (error) {
    console.error('Error fetching remaining stock:', error);
    return 0; // Return 0 if there's an error
  }
};


useEffect(() => {
    if (modalData && modalData.length > 0) {
        const initialRowData = modalData.map(() => ({
            supplementaryFood: '',
            beneficiaryExpenditure: ''
        }));
        setRowInputData(initialRowData); 
    }
}, [modalData]); 


      const DB_NAME = 'SchoolManagementDB';
    const SCHOOL_STORE = 'schoolData';
    const DB_VERSION = 1;



const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = (event) => {
      console.error("IndexedDB error:", event.target.error);
      reject(event.target.error);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;
      if (!db) {
        console.error("Error: db object is not initialized");
        reject("Error: db object is not initialized");
      } else {
        resolve(db);
      }
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;

    
      if (!db.objectStoreNames.contains(SCHOOL_STORE)) {
        db.createObjectStore(SCHOOL_STORE, { keyPath: "udiseNumber" });
      }
    };
  });
};

  
     const fetchSchoolData = async () => {
  try {
    const db = await openDB();
    const transaction = db.transaction(SCHOOL_STORE, "readonly");
    const store = transaction.objectStore(SCHOOL_STORE);
    const udise = localStorage.getItem("udiseNumber");
    const request = store.get(udise);

    return new Promise((resolve) => {
      request.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {
          console.log("School data from IndexedDB:", data);
          setSchoolData(data);
          resolve(data);
        } else {
          console.log("No school data found in IndexedDB, fetching from Firebase");
        }
      };

      request.onerror = (event) => {
        console.error("Error fetching school data from IndexedDB:", event.target.error);
      };
    });
  } catch (error) {
    console.error("Error accessing IndexedDB:", error);
  }
};


  const fetchModalData = async () => {
    const dataPromises = [];
    const remainingStockPromise = fetchRemainingStock(year, month); // Fetch remaining stock
    const currentMonthTandulPromise = fetchCurrentMonthTandul(year, month); // Fetch current month tandul

    const days = {
        1: 'Monday',    // Monday
        2: 'Tuesday',   // Tuesday
        3: 'Wednesday', // Wednesday
        4: 'Thursday',  // Thursday
        5: 'Friday',    // Friday
        6: 'Saturday'   // Saturday
    };

    // Array to store the final combined data
    let finalData = [];

    // Iterate through each day of the week
    for (let dayOfWeek = 1; dayOfWeek <= 6; dayOfWeek++) { 
        const dayName = days[dayOfWeek];

        // Find the first occurrence of the day in the selected month
        let firstOccurrenceDate = new Date(year, dateObject.getMonth(), 1);

        // Move to the first occurrence of the current dayOfWeek
        while (firstOccurrenceDate.getDay() !== dayOfWeek) {
            firstOccurrenceDate.setDate(firstOccurrenceDate.getDate() + 1);
        }

        // Now iterate through all occurrences of that weekday in the selected month
        let currentDate = firstOccurrenceDate;
        while (currentDate.getMonth() === dateObject.getMonth() && currentDate.getFullYear() === year) {
            const dayString = String(currentDate.getDate()).padStart(2, '0'); 
            const formattedDate = `${dayString}-${month}-${year}`; 

            const fetchDataUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/dainandinnondani/${selectedClass}/${year}/${month}/${dayName}/${dayString}.json`;

            dataPromises.push(
                fetch(fetchDataUrl).then(response => response.json()).then(data => {
                    if (data) {
                        finalData.push({ date: formattedDate, foodItems: data });
                    }
                })
            );

            // Move to the next occurrence of the same weekday (7 days later)
            currentDate.setDate(currentDate.getDate() + 7);
        }
    }

    try {
      // Wait for all data to be fetched
      await Promise.all(dataPromises);
  
      const remainingTandul = await remainingStockPromise; // Wait for the remaining stock
      const currentTandul = await currentMonthTandulPromise; // Wait for current month tandul
      setCurrentMonthTandul(currentTandul);
      // Calculate the expenseTotal for each item using the defined expenseValue
      const updatedFinalData = finalData.map(item => {
        return {
          ...item,
          remainingTandul,
          expenseTotal: (expenseValue * (item.foodItems.labharthi || 0)) || 0 // Use the defined expenseValue
        };
      });
  
      setModalData(updatedFinalData);
      // Set the initial row data if necessary
      const initialRowData = updatedFinalData.map(() => ({
        supplementaryFood: '',
        beneficiaryExpenditure: ''
      }));
      setRowInputData(initialRowData);
    } catch (error) {
      console.error('Error fetching modal data from Firebase:', error);
    }
  };


const fetchexpense = async () => {
  const fetchpramanUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/poshanaahar/praman/${selectedClass}.json`;
  
  try {
    const response = await axios.get(fetchpramanUrl);
    const fetchedExpenseData = response.data || {}; // Store the fetched expense data
    setExpenseData(fetchedExpenseData);

    // Assuming the expense value you need is stored under a specific key
    const expenseKey = language === "English" ? "Expenses" : "खर्च";
    setExpenseValue(fetchedExpenseData[expenseKey] || 0); // Set the expenseValue
  } catch (error) {
    console.error('Error fetching expense data from praman node:', error);
  }
};

const handleFetchStudentCount = async () => {
  try {
    // Construct the fetch URL
    const fetchUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;

    // Fetch student data from Firebase
    const response = await axios.get(fetchUrl);
    const studentData = response.data || {};


    if (!studentData) {
      return; // or throw an error if needed
    }

    // Declare class ranges
    let classRange1 = [];
    let classRange2 = [];

    // Set class ranges based on the language
    if (language === 'English') {
      classRange1 = ['Class I', 'Class II', 'Class III', 'Class IV', 'Class V'];
      classRange2 = ['Class VI', 'Class VII', 'Class VIII'];
    } else {
      classRange1 = ['इयत्ता पहिली', 'इयत्ता दुसरी', 'इयत्ता तिसरी', 'इयत्ता चौथी', 'इयत्ता पाचवी'];
      classRange2 = ['इयत्ता सहावी', 'इयत्ता सातवी', 'इयत्ता आठवी'];
    }

    let countClass1to5 = 0;
    let countClass6to8 = 0;

    // Iterate over student data
    Object.values(studentData).forEach((student) => {
      if (student !== null) { 

        const trimmedCurrentClass = student.currentClass.trim(); // Trim extra spaces

        if (classRange1.includes(trimmedCurrentClass)) {
          countClass1to5++;
        } else if (classRange2.includes(trimmedCurrentClass)) {
          countClass6to8++;
        }
      }
    });

    if (selectedClass === '1 To 5') {
      setCountTotal(countClass1to5)
    }
    else{
      setCountTotal(countClass6to8)
    }

    // Return the counts if needed
    return { countClass1to5, countClass6to8 };
  } catch (error) {
    console.error('Failed to fetch student data:', error);
  }
};

  useEffect(() => {
    fetchexpense();
    fetchSchoolData(); 
    fetchModalData(); 
    handleFetchStudentCount();
  }, [selectedDate, selectedClass]); 

  const closeModal = () => {
    navigate('/dainandin') 
  };

  const handlePrint = () => {
    const printContent = document.querySelector('.modal-content');
  
    if (printContent) {
      const cloneContent = printContent.cloneNode(true);
  
      const schoolName = cloneContent.querySelector('p'); 
      const otherDetails = cloneContent.querySelectorAll('p'); 
      
      otherDetails.forEach((p, index) => {
        if (index !== 0) { 
          p.style.fontWeight = 'normal'; 
        }
      });
          
      if (schoolName) {
        schoolName.innerHTML = `<h5 style="font-size: 16px; margin-top: 10px;">${schoolData.schoolName}</h5>`; // Increase the font size and set top margin
      }
  
      const printWindow = window.open('', '', 'height=600,width=800');
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Modal Content</title>
            <style>
              @media print {
                @page {
                  size: A4 landscape; /* Set the page size to landscape */
                  margin: 3mm;      /* Remove default margins */
                }
  
                body {
                  margin: 5px;  
                  margin-top: 15px;    /* Remove body margin */
                  padding: 0;     /* Remove body padding */
                }
  
                /* Ensure that the table takes full width */
                table {
                  width: 100%;    /* Make the table full width */
                  border-collapse: collapse; /* Collapse borders */
                  padding: auto 80px;
                }
  
                th, td {
                  border: 1px solid black; /* Add border to table cells */
                  padding: 8px;            /* Add padding for readability */
                  text-align: left;        /* Align text to the left */
                }
  
                th {
                  font-weight: normal !important;  /* Remove bold text from table headers */
                  font-size: 12px !important;
                }
  
.Dailyrgposhan{
margin:0 auto;
}
.last2td input {
  padding: 0;
  margin: 0;
  width: 50px;
}
  .last2td textarea {
   padding: -5px;
   margin:  -5px;
          border: none;
            outline: none;
            text-align: center;
            resize: none; // Prevent resizing if you want to control size
            width: '100%';  // Make textarea take full width of cell
            max-width: 'fit-content'; // Adjust max width to fit content
            min-width: '60px'; // Optional: set a minimum width
            min-height: '50px'; // Optional: set a minimum height for better usability
            overflow: 'hidden';
            font-size:9px; 
}
                
            /* Add styles for the certificate text */
                .Certificate-dailyposhan {
                  text-align: center;
                   margin-top: 1rem;
                }
                .certificate-part-poshan{
                 display: flex;
                 justify-content: center ;
                 margin-top:-20px;
                }
                   .certificate-text {
             text-align: left;
             width: 74%;
             font-size:13px;
          }
          .signature-section {
            display: flex;
             justify-content: space-between;
              margin-top:10px;
              font-size:'13px;
          }
        .principal-signature{
        text-align: 'right'
        }
          .schmgnt{
          margin-top: 0px;
          }

          .president-signature {
           text-align: center;
          }
  
                /* Optional: scale down table for smaller print size */
                table {
                  transform: scale(0.98);
                  transform-origin: center;
                }
                .no-print {
                  display: none;
                }
              }
  
            </style>
          </head>
          <body>
            ${cloneContent.outerHTML} <!-- Include the modified outer HTML of the modal content -->
          </body>
        </html>
      `);
      printWindow.document.close(); 
      printWindow.focus(); // Focus the new window
      printWindow.print(); // Trigger print
      printWindow.close(); // Close the print window after printing
    } else {
      console.error('Print content not found');
    }
  };
  return (
    <div> 
<div className='main-content-of-page'>
      {showModal && (
          <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '1000',
          }}>
            <div style={{
              backgroundColor: '#fff',
              padding: '30px',
              borderRadius: '10px',
              width: '100%',
              boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
              maxHeight: '90%',
              overflowY: 'auto',
              position: 'relative',
            }}>

              <div className="modal-content">
               
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  marginBottom: '30px',
                  fontFamily: 'Arial, sans-serif',
                  border: '1px solid black',
                  borderRadius: '10px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                }}>
                
                  <thead>
                    {schoolData && (
                      <tr>
  <th colSpan="23" style={{
    color: 'black',
    padding: '5px',
    borderRadius: '10px 10px 0 0',
    textAlign: 'center',
    lineHeight: '0.4',
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    borderTop: '1px solid black',
    fontSize: '13px',
    position: 'relative' 
  }}>
    <p><strong><h6> {schoolData.schoolName}</h6></strong></p>
    <p>{schoolData.sansthaName}</p>
    <p>{language === "English" ? "Taluka:" : "तालुका:"} {schoolData.taluka} , {language === "English" ? "Jilha:" : "जिल्हा:"} {schoolData.jilha} </p>
    <p>{language === "English" ? "Pradhan Mantri Poshan Shakti Nirman Yojana" : "प्रधानमंत्री पोषण शक्ती निर्माण योजना"}  </p>

    <p className='Dailyrgposhan' style={{ display: 'inline-block', backgroundColor: '#252729', color: 'white', padding: '10px', borderRadius: '5px', fontSize: '14px' }}>
    {language === "English" ? "Daily Register to be maintained at school level Part-II (Accounting of Cereals)" : " नोंदवही भाग-1 तांदळाचा हिशोब"} ({language === "English" ? `Class ${classMapping[selectedClass].English}` : `इयत्ता ${classMapping[selectedClass].Marathi}`}) 
                          </p>
    <p style={{fontSize:'16px'}}><p style={{ position: 'absolute', right: '10px', bottom:'2px'}}>{language === "English" ? "Month: " : "महिना: "}{monthName} {year}</p> {language === "English" ? 'Rice In Kilogram' :  'तांदूळ किलोग्रॅममध्ये'}</p>

  </th>
</tr>
                    )}
                    <tr style={{ color: 'black' }}>
                      <th style={{ borderLeft: '1px solid black',width:'100px', ...thstyle, padding:'auto 0px' }}>{language === "English" ? "Sr. No" : "Sr. No"}</th>
                      <th style={{ borderLeft: '1px solid black',width:'100px', ...thstyle, padding:'auto 0px' }}>{language === "English" ? "Date" : "तारीख"}</th>
                      <th style={thstyle}>{language === "English" ? "Students Strength" : "पटसंख्या"}</th>
                      <th style={thstyle}>{language === "English" ? "Left over rice from last month" : "मागील महिना शिल्लक तांदूळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Rice received in current month" : "चालू महिना प्राप्त तांदूळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Total Rice" : "एकूण तांदूळ"}</th>
                      <th style={thstyle}>{language === "English" ? "labharthi sankhya" : "लाभार्थी संख्या"}</th>
                      <th style={thstyle}>{language === "English" ? "Cooked rice" : "शिजवलेला तांदूळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Leftover rice" : "शिल्लक तांदूळ"}</th>
                      <th style={thstyle}>{language === "English" ? "Principle signature" : "मुख्याध्यापक सही"}</th>
                      <th style={thstyle}>{language === "English" ? "Signature of School Visiting Officer" : "शाळा भेट अधिकारी सही"}</th>
                    </tr>
                  </thead>

                  <tbody>
  {modalData && modalData.length > 0 && 
    modalData
      .sort((a, b) => new Date(a.date.split('-').reverse().join('-')) - new Date(b.date.split('-').reverse().join('-')))
      .map((item, index) => {
        const openingBalance = index === 0 
          ? item.remainingTandul : modalData[index - 1].remainingRice || 0; 

        const currentMonthRice = index === 0 ? currentMonthTandul : 0;

        const totalRice = (parseFloat(openingBalance) + parseFloat(currentMonthRice));

        const cookedRice = parseFloat(item.foodItems.तांदूळ) || parseFloat(item.foodItems.Rice) || 0;

        const remainingRice = totalRice - cookedRice;

        item.remainingRice = remainingRice;
        return (
          <tr key={index}>
            <td style={{...thstylebody, borderLeft: '1px solid black', padding:'15px 0'}}>{index + 1}</td>
            <td style={{...thstylebody, borderLeft: '1px solid black', padding:'15px 0'}}>{item.date}</td>
            <td style={thstylebody}>{countTotal || ''}</td>
            <td style={thstylebody}>{(openingBalance / 1000).toFixed(2)}</td> 
            <td style={thstylebody}>{(currentMonthRice / 1000).toFixed(2)}</td> 
            <td style={thstylebody}>{parseFloat(totalRice / 1000).toFixed(2)}</td> 
            <td style={thstylebody}>{item.foodItems.labharthi || ''}</td>
            <td style={thstylebody}>{(cookedRice / 1000).toFixed(2)}</td>
            <td style={thstylebody}>{(isNaN(remainingRice) ? '' : (remainingRice / 1000).toFixed(2))}</td>
            <td style={thstylebody}></td>
            <td style={thstylebody}></td>
          </tr>
        );
      })
  }

  {/* Total Row */}
  <tr>
    <td style={{...thstylebody, borderLeft: '1px solid black', fontWeight: 'bold', padding:'auto 0px'}}> Total</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}></td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{modalData.reduce((acc, item) => acc + (parseFloat(countTotal) || 0), 0)}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{modalData.reduce((acc, item, index) => {
      const openingBalance = index === 0 ? item.remainingTandul : modalData[index - 1].remainingRice || 0;
      return acc + (openingBalance || 0);
    }, 0) / 1000}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{(currentMonthTandul / 1000).toFixed(2)}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>
      {modalData.reduce((acc, item, index) => {
        const openingBalance = index === 0 ? item.remainingTandul : modalData[index - 1].remainingRice || 0;
        const currentMonthRice = index === 0 ? currentMonthTandul : 0;
        const totalRice = parseFloat(openingBalance) + parseFloat(currentMonthRice);
        return acc + (totalRice || 0);
      }, 0) / 1000}
    </td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{modalData.reduce((acc, item) => acc + (parseFloat(item.foodItems.labharthi) || 0), 0)}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{modalData.reduce((acc, item) => {
      const cookedRice = parseFloat(item.foodItems.तांदूळ || item.foodItems.Rice || 0);
      return acc + (cookedRice || 0);
    }, 0) / 1000}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}>{modalData.reduce((acc, item, index) => {
      const openingBalance = index === 0 ? item.remainingTandul : modalData[index - 1].remainingRice || 0;
      const currentMonthRice = index === 0 ? currentMonthTandul : 0;
      const totalRice =  parseFloat(openingBalance) + parseFloat(currentMonthRice);
      const cookedRice = parseFloat(item.foodItems.तांदूळ || item.foodItems.Rice || 0);
      const remainingRice = parseFloat(totalRice) - parseFloat(cookedRice);
      return acc + (remainingRice || 0);
    }, 0) / 1000}</td>
    <td style={{...thstylebody, fontWeight: 'bold'}}></td>
    <td style={{...thstylebody, fontWeight: 'bold'}}></td>
  </tr>
</tbody>
                </table>

                <div className='text-center mt-3 Certificate-dailyposhan'>
  <p>{language === "English" ? "Certificate" : "प्रमाणपत्र"} </p>
  <div className='certificate-part-poshan' style={{ display: 'flex', justifyContent: 'center' }}>
    <p className='certificate-text'  style={{ textAlign: 'left', width: '74%', fontSize:'13px' }}>
      {language === "English"
        ? "It is hereby certified that the amount mentioned above has been spent on the purchase of vegetables, supplementary food, fuel, and grains required for the beneficiaries of the school nutrition program. The expenditure is appropriate, and the items have been used in the daily cooking as per the prescribed guidelines of the government for the school nutrition meal scheme. I am confident that the use of these materials is accurate and correct. Therefore, this certificate is being issued."
        : "प्रमाणित करण्यात येते की, वरील समाविष्ठ असलेली रकुम शाळेतील शालेय पोषण आहार लाभार्थींसाठी लागणारा भाजीपाला, पुरक आहार, इंधन आणि धान्यादी साहीत्यासाठी मी खर्च केलेला असून तो योग्य आहे आणि शालेय पोषण आहार भोजन यासाठी शासनाने निर्देशित केलेल्या प्रमाणात वरील साहित्याचा वापर प्रत्यक्ष दैनंदिन पाककृतीमध्ये केलेला आहे व तो बरोबर आहे, याची मला खात्री आहे. करिता प्रमाणपत्र करण्यात येते."}
    </p>    
  </div>
  <div className='signature-section' style={{ display: 'flex', justifyContent: 'space-between', margin: '0 auto', padding: '0 20px', fontSize: '13px', width: '70%', alignItems: 'center', marginTop: '10px' }}>
  <p>{language === "English" ? "Signature of Principal" : "मुख्याध्यापक स्वाक्षरी"}</p>
  <div className='principal-signature' style={{ textAlign: 'right' }}>
    <p className='president-signature' style={{ textAlign: 'center', marginBottom: '0' }}>
      {language === "English" ? "President" : "अध्यक्ष"}
    </p>
    <p className='schmgnt'>{language === "English" ? "School Management Committee" : "शाळा व्यवस्थापन समिती"}</p>
  </div>
 
</div>
</div>
              </div>
              <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <button onClick={handlePrint} style={{
          padding: '12px 20px',
          backgroundColor: '#007BFF',
          color: '#fff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '16px',
          boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
          transition: 'background-color 0.2s ease',
          marginRight: '10px',
        }}>
         {language === "English" ? "Print" : "प्रिंट करा"} 
        </button>
                <button onClick={closeModal} style={{
                  padding: '12px 20px',
                  backgroundColor: '#FF4136',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                  transition: 'background-color 0.2s ease',
                }}
                  onMouseOver={(e) => e.target.style.backgroundColor = '#E04A3F'}
                  onMouseOut={(e) => e.target.style.backgroundColor = '#FF4136'}
                >
               {language === "English" ? "Close" : " बंद करा"}                          
                </button>
              </div>
            </div>
          </div>
        )}

        </div>
    </div>
  );
}
export default DainandinNondvahiTandulkReport;

const thstyle={
  fontSize:'14px',
  padding: '0px',
  fontWeight: '600',
  borderBottom: '1px solid black',
  textAlign: 'center',
  borderRight: '1px solid black',
  borderRight: '1px solid black',
  width:'60px', 
  backgroundColor:'none',
  color:'black'
}

const thstylebody={
  fontSize:'12px',
  padding: '7px',
  borderBottom: '1px solid black',
  textAlign: 'center',
  color: 'black',
  borderRight: '1px solid black',
}